import { type ReactNode, type RefObject, type JSX } from 'react';
import { useIntl } from '@doxyme/locale';
import { useTheme } from '../../../../theme';

export type CallControlBarProps = {
  controlBarRef?: RefObject<HTMLDivElement | null>;
  children: ReactNode;
};

export const CallControlBarContainer = ({
  controlBarRef,
  children,
}: CallControlBarProps): JSX.Element => {
  const { formatMessage } = useIntl();
  const theme = useTheme('dark');

  return (
    <div
      role='toolbar'
      ref={controlBarRef}
      aria-label={formatMessage({ id: 'callControlBar' })}
      css={{
        display: 'flex',
        width: 'fit-content',
        justifyContent: 'center',
        alignItems: 'center',
        gap: theme.spacing(2),
        borderRadius: theme.shape.radius12,
        margin: '0 auto',
      }}
    >
      {children}
    </div>
  );
};
